import React from 'react';
import { LegendItemContainer } from './style';

export const LegendItem = ({
  backgroundColor,
  borderColor,
  iconComponent,
  legendTitle,
}) => {
  return (
    <LegendItemContainer
      backgroundColor={backgroundColor}
      borderColor={borderColor}
    >
      <div className='iconContainer'>{iconComponent}</div>
      <div className='legendTitle'>{legendTitle ? legendTitle : 'error'}</div>
    </LegendItemContainer>
  );
};
